import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Third party
import { NgArrayPipesModule } from 'ngx-pipes';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip/tooltip.module';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { NgSelectModule } from '@ng-select/ng-select';

// Local modules
import { SharedModule } from '../shared/shared.module';
import { IwFormsModule } from '../forms/iw-forms.module';
import { DragulaModule } from 'ng2-dragula';

// Local components
import { FlowComponent } from './flow.component';
import { SelectProcessComponent } from './select-process/select-process.component';
import { DynamicContentFormComponent } from '@app/components/dynamic-content-form/dynamic-content-form.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TooltipModule,
    BsDropdownModule,
    NgArrayPipesModule,
    NgxPaginationModule,
    PaginationModule,
    ScrollToModule,
    NgSelectModule,
    DragulaModule,
    CollapseModule,
    IwFormsModule,
    ButtonsModule.forRoot()
  ],
  declarations: [
    FlowComponent,
    SelectProcessComponent
  ],
  exports: [
    FlowComponent
  ],
  entryComponents: [
    DynamicContentFormComponent
  ],
  providers: []
})
export class FlowModule {}



// WEBPACK FOOTER //
// ./src/app/flow/flow.module.ts